module.exports = __webpack_public_path__ + "static/media/hilda_again_by_corriger-dbobtt0.2a69a20a.png";